 
namespace TabAurous.ProductDevelopment { 
    @Serenity.Decorators.registerClass()
    export class QuotationItemsEditorForPD extends _Ext.GridEditorBase<PDQuotationItemsRow> {
        protected getColumnsKey() { return "ProductDevelopment.QuotationItemsForPD"; }
        protected getDialogType() { return PDQuotationItemsForPD; }
        protected getLocalTextPrefix() { return PDQuotationItemsRow.localTextPrefix; }
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            opt.EnableQuickSearch = true;
            return opt;
        }
        constructor(container: JQuery) {
            super(container);
             
            this.slickGrid.setOptions({ rowHeight: 30 });
          
        }
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;

        }
        setData(Items) {
            this.view.setItems([]);
            for (let item of Items) {

                item[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(item);

            }
        }
    }
}